(function (angular) {
    'use strict';

    angular.module('app')
        .directive('imageDrop', imageDrop);

    imageDrop.$inject = [
        'alerts',
        'settings',
        'modalService',
        'Upload'
    ];

    function imageDrop(
        alerts,
        settings,
        modalService,
        Upload
    ) {
        function imageDropLink($scope) {

            // properties
            $scope.options = angular.merge({
                filePattern: 'image/*',
                maxFilesize: settings.maxImageUploadSize,
                dragOverClass: 'dragging',
                resize: false,
                resizeSize: {
                    w: 200,
                    h: 200
                },
                resizeShape: 'square',
                resizeAspectRatio: 1
            }, $scope.options);

            // methods
            $scope.handleImage = handleImage;

            /**
             * Resizes image if requested, then passes to parent controller
             * @param  {file} file - file object provided by ngUpload plugin
             * @return {void}
             */
            function handleImage(file) {
                // Don't do anything if the file is empty
                if (!file || !file.name) { return false; }

                // Check the filesize
                if (file.size > $scope.options.maxFilesize) {
                    $scope.onError({
                        image: `Maximum filesize is ${$scope.options.maxFilesize}`,
                    });
                    return false;
                }

                // convert to base64
                Upload.base64DataUrl(file).then(function (base64Image) {
                    if (!base64Image) {
                        alerts.emit({
                            title: 'Image couldn\'t be converted to the correct format',
                            theme: 'error'
                        });
                    } else {
                        // resize and return
                        if ($scope.options.resize) {
                            modalService.open({
                                templateUrl: 'modals/resize-image.html',
                                controller: 'resizeImageController',
                                controllerAs: 'vm',
                                windowClass: 'resize-image',
                                resolve: {
                                    originalImage: function () {
                                        return base64Image;
                                    },
                                    resizeOptions: function () {
                                        return {
                                            shape: $scope.options.resizeShape,
                                            size: $scope.options.resizeSize,
                                            aspectRatio: $scope.options.resizeAspectRatio
                                        };
                                    }
                                }
                            }).result.then(function (resizedImage) {
                                $scope.onSelect(resizedImage);
                            });
                        } else {
                            $scope.onSelect(base64Image);
                        }
                    }
                });
            }
        }

        return {
            templateUrl: 'directives/image-drop.html',
            transclude: true,
            scope: {
                ngModel: '=',
                url: '=?',
                onSelect: '=',
                onError: '=',
                options: '=?'
            },
            link: imageDropLink
        };
    }

}(angular));
